var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _g, _path84, _path85, _g2, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 565,
    height: 515,
    viewBox: "0 0 565 515",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_401_54310)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M547.104 444.844H25.7092C21.0725 444.844 16.6257 443 13.3471 439.717C10.0685 436.434 8.22656 431.981 8.22656 427.338C197.232 405.343 382.686 405.343 564.587 427.338C564.587 431.981 562.745 436.434 559.466 439.717C556.188 443 551.741 444.844 547.104 444.844Z",
    fill: "#2F2E41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M564.587 428.368L8.22656 427.338L72.7068 318.698L73.0153 318.183V78.7518C73.0151 75.8456 73.5865 72.9678 74.6971 70.2828C75.8076 67.5978 77.4355 65.1582 79.4878 63.1032C81.54 61.0482 83.9764 59.4181 86.6578 58.3061C89.3392 57.1941 92.2131 56.6218 95.1154 56.6221H474.613C477.515 56.6218 480.389 57.1941 483.071 58.3061C485.752 59.4181 488.188 61.0482 490.241 63.1032C492.293 65.1582 493.921 67.5978 495.031 70.2828C496.142 72.9678 496.713 75.8456 496.713 78.7518V319.831L564.587 428.368Z",
    fill: "#3F3D56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6109 72.0684C92.7023 72.0705 90.8725 72.8306 89.5229 74.182C88.1734 75.5334 87.4143 77.3656 87.4121 79.2767V297.587C87.4143 299.499 88.1735 301.331 89.523 302.682C90.8726 304.033 92.7023 304.794 94.6109 304.796H478.201C480.11 304.794 481.94 304.033 483.289 302.682C484.639 301.331 485.398 299.499 485.4 297.587V79.2767C485.398 77.3656 484.639 75.5335 483.289 74.1821C481.94 72.8308 480.11 72.0706 478.201 72.0684H94.6109Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2175 333.63C95.6277 333.631 95.0505 333.801 94.5539 334.119C94.0573 334.438 93.662 334.892 93.4145 335.428L73.5462 378.678C73.3299 379.149 73.2353 379.666 73.2711 380.183C73.3069 380.7 73.4719 381.2 73.751 381.636C74.0301 382.072 74.4143 382.431 74.8682 382.68C75.3221 382.928 75.8312 383.059 76.3486 383.059H494.17C494.696 383.059 495.213 382.924 495.672 382.668C496.131 382.411 496.518 382.041 496.794 381.593C497.071 381.145 497.228 380.634 497.251 380.108C497.275 379.582 497.164 379.059 496.929 378.588L475.332 335.337C475.078 334.823 474.684 334.391 474.197 334.089C473.709 333.787 473.147 333.628 472.574 333.63H96.2175Z",
    fill: "#2F2E41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M284.862 68.4642C287.418 68.4642 289.49 66.3895 289.49 63.8302C289.49 61.271 287.418 59.1963 284.862 59.1963C282.306 59.1963 280.234 61.271 280.234 63.8302C280.234 66.3895 282.306 68.4642 284.862 68.4642Z",
    fill: "white",
    fillOpacity: 0.29
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M243.795 391.297C243.117 391.298 242.458 391.522 241.92 391.935C241.381 392.348 240.994 392.927 240.817 393.583L235.833 412.119C235.71 412.576 235.693 413.056 235.785 413.522C235.877 413.987 236.075 414.425 236.363 414.801C236.651 415.177 237.021 415.482 237.446 415.692C237.871 415.902 238.338 416.011 238.812 416.011H333.592C334.084 416.011 334.568 415.894 335.006 415.668C335.443 415.442 335.82 415.115 336.105 414.714C336.39 414.313 336.575 413.849 336.645 413.361C336.715 412.874 336.667 412.377 336.506 411.911L330.099 393.375C329.889 392.769 329.495 392.242 328.973 391.87C328.45 391.497 327.825 391.297 327.184 391.297H243.795Z",
    fill: "#2F2E41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M496.713 314.579V318.698H72.707L73.0261 318.183V314.579H496.713Z",
    fill: "#2F2E41"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_401_54310",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 72,
    width: 399,
    height: 234
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6675 72.5C91.7589 72.5021 89.9291 73.2623 88.5796 74.6137C87.23 75.965 86.4709 77.7972 86.4688 79.7084V298.019C86.471 299.93 87.2301 301.762 88.5797 303.114C89.9292 304.465 91.759 305.225 93.6675 305.227H477.258C479.166 305.225 480.996 304.465 482.346 303.114C483.695 301.762 484.454 299.93 484.457 298.019V79.7084C484.454 77.7973 483.695 75.9651 482.346 74.6138C480.996 73.2624 479.167 72.5022 477.258 72.5H93.6675Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_401_54310)"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M111.393 184.908C111.178 186.865 129.403 205.812 138.468 235.083C152.255 279.59 154.125 315.474 150.332 320.305C144.387 327.849 137.339 310.494 135.294 306.688C125.973 289.361 119.14 270.697 114.971 251.466C110.25 229.672 108.959 207.108 111.393 184.922V184.908Z",
    fill: "url(#paint0_linear_401_54310)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M190.467 298.821C205.464 296.418 220.864 297.862 235.74 300.926C252.701 304.421 270.16 310.629 281.122 324.07C275.378 322.464 269.46 325.325 264.067 327.835C248.101 335.257 230.885 340.237 213.319 341.263C195.753 342.288 177.823 339.279 162.033 331.492C158.065 329.536 153.008 326.499 151.636 321.951C150.035 316.661 155.402 313.827 159.383 311.02C168.583 304.542 179.424 300.588 190.48 298.807L190.467 298.821Z",
    fill: "url(#paint1_linear_401_54310)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M262.641 211.723C267.322 212.681 262.937 216.311 260.61 219.267C256.414 224.584 252.446 230.076 247.926 235.124C238.108 246.082 226.662 255.474 214.503 263.679C196.479 275.852 176.896 285.487 157.393 295.082C166.767 277.593 179.007 261.614 193.601 248.2C203.285 239.294 214.032 231.52 225.626 225.299C231.41 222.195 237.408 219.469 243.555 217.188C248.169 215.475 257.624 210.751 262.547 211.696C262.574 211.696 262.601 211.696 262.641 211.709V211.723Z",
    fill: "url(#paint2_linear_401_54310)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M161.725 191.926C159.479 173.572 154.408 155.3 144.589 139.659C145.827 141.616 142.841 152.088 142.612 154.747C142.168 159.807 141.953 164.882 141.94 169.956C141.899 199.443 148.369 226.379 162.142 252.465C164.186 232.101 164.227 212.223 161.725 191.912V191.926Z",
    fill: "url(#paint3_linear_401_54310)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M213.549 175.448C229.407 169.807 247.686 169.052 264.364 168.08C255.581 176.825 246.65 185.678 235.917 191.859C226.179 197.472 216.589 199.227 205.532 199.186C201.618 199.186 197.839 199.929 193.898 199.807C191.907 199.74 182.909 197.823 181.537 199.767C189.634 188.242 200.919 179.942 213.535 175.448H213.549Z",
    fill: "url(#paint4_linear_401_54310)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M182.196 201.035C169.257 173.761 170.804 140.631 182.438 113.209C184.752 107.757 186.554 102.912 190.656 98.418C189.957 99.1872 192.822 108.58 193.064 110.037C193.75 114.099 194.274 118.188 194.638 122.304C195.364 130.523 195.458 138.782 194.92 147.014C193.884 162.844 190.656 178.566 184.523 193.154C183.81 194.854 181.295 199.132 182.21 201.035H182.196Z",
    fill: "url(#paint5_linear_401_54310)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M226.784 120.051C217.705 131.954 209.083 144.356 201.403 157.23C193.723 170.078 187.052 183.546 181.134 197.297C169.243 224.908 160.366 253.707 154.744 283.261C153.157 291.561 151.852 299.887 150.83 308.281C150.319 312.532 149.862 316.783 149.472 321.048C149.081 325.312 148.786 329.469 149.942 333.639C150.225 334.678 151.96 335.096 152.444 333.963C153.91 330.535 154.462 327.067 154.838 323.369C155.215 319.671 155.645 315.812 156.129 312.033C157.071 304.665 158.214 297.31 159.505 289.996C162.088 275.421 165.437 260.981 169.539 246.771C177.798 218.147 189.002 190.509 202.641 164.045C206.474 156.609 210.253 149.106 214.45 141.873C218.646 134.639 223.045 127.541 227.645 120.564C228.008 120.011 227.16 119.565 226.784 120.065V120.051Z",
    fill: "#007347"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M258.741 281.128C257.02 280.17 255.298 279.212 253.818 278.038C250.389 275.339 248.21 271.398 245.479 267.984C242.749 264.57 238.956 261.452 234.611 261.587C231.047 261.695 227.711 265.123 227.846 268.402C219.722 241.115 207.751 214.988 192.378 191.048C188.921 185.664 185.074 180.184 179.465 177.108C175.941 175.164 171.449 174.355 167.938 176.338C165.733 177.593 164.199 179.78 162.962 181.993C158.052 190.792 156.479 201.021 155.349 211.021C153.721 225.38 152.834 239.833 152.699 254.286C152.538 251.344 148.799 249.698 146.014 250.643C143.23 251.587 141.374 254.178 139.962 256.756C136.841 262.464 134.972 268.861 134.541 275.352C132.255 270.427 132.026 264.799 130.103 259.711C128.193 254.637 123.485 249.779 118.145 250.71C113.855 251.466 111.03 255.622 109.335 259.644C107.506 263.962 105.435 272.491 104.561 281.115H258.728L258.741 281.128Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M227.002 199.193L157.978 204.96C150.733 205.565 145.348 211.949 145.952 219.218L152.577 299.043C153.18 306.312 159.543 311.715 166.788 311.109L235.811 305.343C243.057 304.737 248.441 298.353 247.838 291.084L241.213 211.26C240.61 203.99 234.247 198.588 227.002 199.193Z",
    fill: "#787F8F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M146.717 228.369C148.422 223.683 152.699 220.161 157.985 219.726L230.839 213.643C235.146 213.278 239.131 215.06 241.784 218.076L241.219 211.274C240.614 204.007 234.248 198.602 227.005 199.21L157.975 204.979C150.732 205.586 145.345 211.973 145.951 219.24L146.707 228.39L146.717 228.369Z",
    fill: "#9CA5BA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M236.961 219.676L257.58 232.439L245.112 246.75L236.961 219.676Z",
    fill: "#CF4259"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M159.629 275.525C159.629 275.525 165.157 294.421 169.676 303.237C169.676 303.237 189.509 310.798 206.587 310.798C223.666 310.798 239.483 296.689 239.483 296.689L243.246 269.482L159.639 275.525H159.629Z",
    fill: "#663E34"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M194.28 304.249L189.508 336.496L190.013 348.328L189.195 370.605H185.675L180.974 346.314L181.983 337.498L169.676 303.237L179.219 299.462L194.28 304.249Z",
    fill: "#663E34"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M182.801 304.726L183.214 327.134L185.696 334.604L189.882 333.976L193.564 309.108L182.801 304.726Z",
    fill: "#8C645A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M240.481 288.885L237.969 332.457L236.143 370.605H231.372L227.427 339.765L228.426 332.457L220.648 302.488L240.481 288.885Z",
    fill: "#663E34"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M233.783 330.979L238.06 330.837L240.481 288.884L231.654 294.936L233.783 330.979Z",
    fill: "#8C645A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M249.419 250.969C249.419 277.67 228.144 297.093 201.15 297.093C174.155 297.093 151.68 277.66 151.68 250.969C151.68 224.279 173.56 202.63 200.545 202.63C227.529 202.63 249.409 224.269 249.409 250.969H249.419Z",
    fill: "url(#paint6_linear_401_54310)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5,
    d: "M184.302 215.11C183.919 220.819 184.524 226.588 185.674 232.185C187.45 240.818 190.496 250.889 196.952 257.255C200.685 260.93 206.435 262.316 211.489 262.762C217.309 263.278 223.271 262.549 228.83 260.768C233.833 259.158 238.968 256.577 242.458 252.529C245.212 249.32 247.139 245.424 248.46 241.365C243.951 219.28 224.219 202.641 200.564 202.641C195.782 202.641 191.172 203.329 186.814 204.594C185.17 207.803 184.545 211.578 184.313 215.12L184.302 215.11Z",
    fill: "url(#paint7_linear_401_54310)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M208.615 284.228C184.455 284.228 164.864 264.573 164.864 240.332C164.864 227.033 170.776 215.12 180.087 207.073C163.321 214.735 151.68 231.506 151.68 250.97C151.68 277.67 174.165 297.093 201.15 297.093C225.986 297.093 245.969 280.635 248.996 257.204C242.408 273.064 226.803 284.218 208.605 284.218L208.615 284.228Z",
    fill: "#CF4259"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M210.764 208.177C223 236.405 223.484 267.174 212.156 295.787",
    stroke: "#FFEBCC",
    strokeWidth: 0.749999,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M167.224 205.697L159.971 224.756L191.051 241.669L212.81 214.361L230.08 235.434L241.641 224.705L226.287 204.665L167.224 205.697Z",
    fill: "#CF4259"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M167.224 202.286L159.971 221.344L190.708 234.512L212.81 210.95L229.737 228.277L241.479 221.688L226.287 201.243L167.224 202.286Z",
    fill: "#FFEBCC"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M178.481 218.389C184.857 220.727 191.767 221.051 198.475 220.666C200.362 220.555 202.268 220.393 204.165 220.17L212.81 210.95L218.439 216.719C219.458 216.304 220.456 215.858 221.435 215.362C225.036 213.52 228.436 211.041 230.736 207.66C230.786 207.589 230.826 207.508 230.877 207.437L226.277 201.243L167.224 202.286L164.934 208.298C168.464 212.812 172.973 216.364 178.471 218.389H178.481Z",
    fill: "#FFC27D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M194.874 170.942C232.618 147.88 259.503 123.07 254.925 115.527C250.347 107.984 216.038 120.563 178.294 143.625C140.55 166.686 113.665 191.496 118.243 199.039C122.821 206.583 157.13 194.003 194.874 170.942Z",
    fill: "#A8253A"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M254.766 152.916C249.52 152.794 244.275 152.683 239.029 152.562",
    stroke: "black",
    strokeWidth: 0.899999,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M195.35 215.819C221.379 215.819 242.48 192.763 242.48 164.322C242.48 135.88 221.379 112.824 195.35 112.824C169.321 112.824 148.221 135.88 148.221 164.322C148.221 192.763 169.321 215.819 195.35 215.819Z",
    fill: "url(#paint8_linear_401_54310)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M195.35 112.824C194.684 112.824 194.029 112.844 193.373 112.875C218.491 114.008 238.536 136.599 238.536 164.322C238.536 192.044 218.491 214.635 193.373 215.769C194.029 215.799 194.684 215.819 195.35 215.819C221.377 215.819 242.48 192.763 242.48 164.322C242.48 135.881 221.377 112.824 195.35 112.824Z",
    fill: "#FFEAE0"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M160.225 171.224C176.375 159.109 194.099 148.735 212.247 139.949C218.592 136.873 225.058 134.039 231.605 131.407C222.96 120.051 209.937 112.824 195.36 112.824C169.334 112.824 148.23 135.881 148.23 164.322C148.23 169.443 148.927 174.392 150.198 179.058C153.496 176.295 156.916 173.714 160.225 171.224Z",
    fill: "#DB6C51"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M150.914 176.336C154.122 176.822 156.906 178.006 159.438 179.919C156.018 160.354 163.009 141.347 167.821 122.541C155.948 131.893 148.221 147.116 148.221 164.332C148.221 168.401 148.665 172.358 149.482 176.154C149.956 176.204 150.44 176.275 150.914 176.346V176.336Z",
    fill: "#663E34"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M169.345 126.144C175.61 125.638 181.925 126.134 188.159 126.752C190.883 127.025 193.616 127.258 196.33 127.622C200.577 128.199 204.773 129.201 209.071 129.403C215.648 129.717 221.711 126.914 228.268 127.47C219.774 118.401 208.163 112.814 195.351 112.814C182.54 112.814 171.222 118.27 162.748 127.146C164.927 126.61 167.166 126.316 169.345 126.144Z",
    fill: "#663E34"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M241.248 179.517C250.412 178.601 256.927 168.656 255.799 157.303C254.672 145.95 246.329 137.49 237.165 138.406C228.001 139.322 221.486 149.268 222.614 160.62C223.741 171.973 232.084 180.434 241.248 179.517Z",
    stroke: "black",
    strokeWidth: 0.899999,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M149.047 170.506C154.585 170 160.133 169.504 165.671 168.998",
    stroke: "black",
    strokeWidth: 0.899999,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M185.948 190.962C197.319 190.962 206.537 181.713 206.537 170.304C206.537 158.895 197.319 149.646 185.948 149.646C174.577 149.646 165.359 158.895 165.359 170.304C165.359 181.713 174.577 190.962 185.948 190.962Z",
    stroke: "black",
    strokeWidth: 0.899999,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M189.288 163.22C189.288 164.839 187.986 166.145 186.372 166.145C184.758 166.145 183.457 164.839 183.457 163.22C183.457 161.601 184.758 160.295 186.372 160.295C187.986 160.295 189.288 161.601 189.288 163.22Z",
    fill: "#663E34"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M197.155 172.288C197.538 174.343 192.595 177.005 186.119 178.24C179.633 179.464 174.064 178.796 173.681 176.742C173.298 174.687 178.241 172.025 184.717 170.79C191.203 169.566 196.772 170.234 197.155 172.288Z",
    fill: "#FF7D7D"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M235.549 153.685C235.549 155.304 234.248 156.61 232.634 156.61C231.02 156.61 229.719 155.304 229.719 153.685C229.719 152.065 231.02 150.76 232.634 150.76C234.248 150.76 235.549 152.065 235.549 153.685Z",
    fill: "#663E34"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M249.026 161.205C249.41 163.26 244.467 165.922 237.99 167.156C231.504 168.381 225.935 167.713 225.552 165.658C225.169 163.604 230.112 160.942 236.588 159.707C243.064 158.472 248.643 159.15 249.026 161.205Z",
    fill: "#FF7D7D"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M173.087 151.509C174.045 151.023 175.125 150.71 176.224 150.517C177.324 150.325 178.403 149.768 179.503 149.455C180.602 149.141 181.752 148.827 182.892 148.604C183.185 148.544 183.488 148.503 183.78 148.453C184.042 148.412 184.083 148.412 183.881 148.432C184.032 148.412 184.184 148.392 184.325 148.382C185.031 148.311 185.777 148.331 186.463 148.149C187.502 147.886 188.138 146.823 187.997 145.791C187.845 144.647 186.968 144.06 185.888 143.928C185.162 143.837 184.345 144.05 183.629 144.161C183.034 144.252 182.448 144.374 181.863 144.515C180.512 144.839 179.231 145.285 177.97 145.872C176.83 146.408 175.548 146.995 174.691 147.947C173.834 148.898 173.148 149.748 172.371 150.629C171.937 151.115 172.472 151.823 173.067 151.53L173.087 151.509Z",
    fill: "#663E34"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M238.929 136.954C236.599 136.124 234.208 135.639 231.727 135.73C230.456 135.78 229.195 135.932 227.954 136.226C227.399 136.357 226.854 136.509 226.31 136.681C225.644 136.894 224.817 137.096 224.252 137.521C223.556 138.058 223.112 138.817 223.354 139.728C223.556 140.477 224.393 141.266 225.23 141.165C226.441 141.003 227.581 140.436 228.761 140.112C229.85 139.819 230.97 139.576 232.09 139.404C234.218 139.07 236.478 138.928 238.627 139.11C239.908 139.222 239.999 137.359 238.919 136.975L238.929 136.954Z",
    fill: "#663E34"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M226.139 178.583C225.938 178.33 220.5 179.291 219.764 179.302C217.625 179.332 215.487 179.13 213.379 178.765C209.041 177.996 205.147 176.397 201.132 174.666C196.28 175.425 192.295 179.99 192.184 184.919C192.013 192.844 200.325 196.538 206.912 197.763C213.913 199.069 221.721 197.419 226.039 191.316C228.671 187.601 229.035 182.115 226.139 178.593V178.583Z",
    fill: "#663E34"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M192.709 188.33C194.606 193.917 201.354 196.71 206.903 197.743C209.677 198.259 212.562 198.299 215.316 197.804C211.755 190.142 200.305 185.354 192.699 188.33H192.709Z",
    fill: "#FF4A65"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M201.093 181.741C203.836 183.644 207.397 184.676 210.656 185.243C216.264 186.225 223.053 185.962 227.996 182.784C227.734 181.245 227.129 179.788 226.13 178.573C225.928 178.32 220.491 179.282 219.755 179.292C217.616 179.322 215.478 179.12 213.369 178.755C209.032 177.986 205.138 176.387 201.123 174.656C200.709 174.717 200.316 174.818 199.922 174.94C199.206 177.44 198.601 180.031 201.093 181.751V181.741Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M196.674 197.844C196.734 198.037 196.714 198.199 196.755 197.875C196.714 198.138 196.896 198.614 197.017 198.836C197.239 199.261 197.612 199.545 198.006 199.798C198.621 200.193 199.428 200.557 200.174 200.466C200.941 200.365 201.708 199.98 201.889 199.15C202.061 198.411 201.788 197.49 201.072 197.126C200.79 196.984 200.497 196.853 200.184 196.772C200.094 196.751 200.003 196.721 199.912 196.691C199.872 196.68 199.821 196.66 199.781 196.64C199.66 196.589 199.69 196.61 199.892 196.691C199.852 196.711 199.105 196.306 199.095 196.306C198.893 196.245 198.651 196.195 198.449 196.215C198.338 196.225 198.621 196.235 198.691 196.276C198.177 196.043 197.622 196.012 197.158 196.387C196.745 196.721 196.492 197.308 196.664 197.844H196.674Z",
    fill: "#FFF3ED"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M214.337 151.084C213.55 153.472 213.439 156.013 213.923 158.482C214.155 159.697 214.528 160.901 215.083 162.015C215.295 162.45 215.557 162.834 215.83 163.239C216.021 163.543 216.314 163.998 216.233 164.13C215.507 165.456 217.353 166.458 218.21 165.294C218.674 164.656 219.713 164.474 220.379 164.879C221.257 165.415 221.105 166.417 221.65 167.166C222.023 167.683 222.8 167.915 223.295 167.379C224.798 165.749 223.002 163.219 221.327 162.521C219.431 161.721 217.423 162.551 216.243 164.14L218.22 165.304C218.826 164.231 218.503 163.148 217.888 162.166C217.272 161.185 216.758 160.254 216.364 159.191C215.466 156.721 215.255 154.079 215.91 151.529C216.173 150.517 214.68 150.112 214.357 151.094L214.337 151.084Z",
    fill: "#FFEAE0"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M216.526 151.447C216.032 155.061 216.486 158.795 217.838 162.186C219.199 161.194 221.288 161.397 222.427 162.631C223.577 163.866 223.628 165.971 222.549 167.257C221.469 168.552 219.401 168.866 217.989 167.945",
    stroke: "#663E34",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M205.379 162.399C207.235 159.717 210.211 157.834 213.429 157.308C216.647 156.782 220.057 157.632 222.659 159.606",
    stroke: "black",
    strokeWidth: 0.899999,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M138.577 161.994C138.577 161.994 125.373 126.762 163.373 105.861C196.622 87.5719 223.556 111.975 223.556 111.975L138.577 161.994Z",
    fill: "url(#paint9_linear_401_54310)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5,
    d: "M162.374 129.11C165.955 134.262 170.636 137.743 175.881 140.031L223.556 111.964C223.556 111.964 196.621 87.5718 163.372 105.851C160.881 107.217 158.611 108.655 156.543 110.132C155.413 116.124 159.761 125.355 162.364 129.1L162.374 129.11Z",
    fill: "url(#paint10_linear_401_54310)"
  }), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M217.968 107.885C205.63 108.816 191.518 112.196 177.304 119.96C154.516 132.409 141.009 149.139 136.883 154.757C137.539 159.21 138.578 161.994 138.578 161.994L167.62 144.899C170.021 143.36 172.472 141.822 174.974 140.293C181.359 136.397 187.644 132.793 193.707 129.544L223.556 111.974C223.556 111.974 221.549 110.162 217.968 107.895V107.885Z",
    fill: "#FFEBCC"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M178.302 143.624C209.08 124.819 237.567 112.987 249.521 113.351C234.864 109.627 207.92 108.392 180.632 123.291C152.841 138.462 138.839 160.021 138.839 160.021L122.225 187.895C131.031 176.559 152.024 159.667 178.292 143.624H178.302Z",
    fill: "url(#paint11_linear_401_54310)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5,
    d: "M186.907 138.513C214.285 122.704 238.687 113.028 249.511 113.351C234.854 109.627 207.909 108.392 180.622 123.291C179.633 123.827 178.665 124.374 177.717 124.93C181.005 129.293 184.022 133.857 186.907 138.503V138.513Z",
    fill: "url(#paint12_linear_401_54310)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5,
    d: "M169.051 130.477C165.954 132.632 163.089 134.819 160.477 136.985C159.619 144.12 157.965 151.134 156.25 158.148C161.294 154.565 166.711 150.922 172.421 147.298C171.472 141.661 170.453 136.033 169.051 130.487V130.477Z",
    fill: "url(#paint13_linear_401_54310)"
  }), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M160.193 178.229C162.2 184.697 159.577 191.266 154.342 192.895C149.106 194.535 143.235 190.618 141.228 184.15C139.22 177.683 141.843 171.114 147.079 169.484C152.314 167.845 158.185 171.762 160.193 178.229Z",
    fill: "url(#paint14_linear_401_54310)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M145.474 180.163C145.07 178.858 145.696 177.309 146.886 176.651C149.64 175.123 153.282 178.392 154.008 180.932C151.345 180.123 149.6 182.805 150.881 185.143C151.617 186.489 153.342 187.197 154.815 186.762",
    stroke: "#663E34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M238.635 275.262L234.015 240.678H212.68L213.366 277.175C213.366 277.246 213.345 277.317 213.345 277.388C213.467 280.192 219.297 282.216 226.359 281.902C233.42 281.588 239.049 279.068 238.928 276.264C238.918 275.92 238.807 275.586 238.635 275.273V275.262Z",
    fill: "#6C6F75"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M225.621 273.411C231.593 273.148 236.526 271.276 237.797 268.998L236.688 260.679C235.366 262.804 230.716 264.535 225.097 264.778C219.327 265.031 214.434 263.634 213.072 261.539L213.234 270.243C214.838 272.308 219.801 273.664 225.631 273.401L225.621 273.411Z",
    fill: "#B0B9CF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M225.571 256.386L224.633 262.378L231.24 265.698L236.678 260.678L236.425 255.121L225.571 256.386Z",
    fill: "#969EB0"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M234.005 240.678C234.005 243.016 229.234 244.909 223.342 244.909C217.451 244.909 212.68 243.016 212.68 240.678C212.68 238.34 217.451 236.447 223.342 236.447C229.234 236.447 234.005 238.34 234.005 240.678Z",
    fill: "#969EB0"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M231.825 240.678C231.825 242.257 228.032 243.542 223.341 243.542C218.65 243.542 214.857 242.257 214.857 240.678C214.857 239.099 218.65 237.813 223.341 237.813C228.032 237.813 231.825 239.099 231.825 240.678Z",
    fill: "#2D364A"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M215.977 258.259L210.388 258.623C207.897 258.785 206.01 256.386 206.757 253.988C207.191 252.571 208.462 251.569 209.934 251.478L215.523 251.113C218.015 250.951 219.901 253.35 219.155 255.749C218.721 257.166 217.45 258.168 215.977 258.259Z",
    fill: "#2D364A"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M212.78 277.601L208.16 243.017H186.824L187.51 279.514C187.51 279.585 187.49 279.656 187.49 279.727C187.611 282.53 193.442 284.555 200.503 284.241C207.565 283.927 213.193 281.407 213.072 278.603C213.062 278.259 212.951 277.925 212.78 277.611V277.601Z",
    fill: "#6C6F75"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M199.778 275.748C205.75 275.485 210.682 273.613 211.953 271.335L210.844 263.016C209.522 265.141 204.872 266.872 199.253 267.115C193.483 267.368 188.59 265.981 187.229 263.876L187.39 272.58C188.994 274.645 193.957 276.001 199.788 275.738L199.778 275.748Z",
    fill: "#B0B9CF"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M208.159 243.016C208.159 245.354 203.388 247.247 197.497 247.247C191.605 247.247 186.834 245.354 186.834 243.016C186.834 240.678 191.605 238.785 197.497 238.785C203.388 238.785 208.159 240.678 208.159 243.016Z",
    fill: "#969EB0"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M197.488 245.88C202.173 245.88 205.971 244.598 205.971 243.016C205.971 241.434 202.173 240.151 197.488 240.151C192.802 240.151 189.004 241.434 189.004 243.016C189.004 244.598 192.802 245.88 197.488 245.88Z",
    fill: "#2D364A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M203.732 263.997L203.167 257.175L187.098 257.58L187.239 264.968L192.686 268.976L203.732 263.997Z",
    fill: "#969EB0"
  }))), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M271.853 253.441L254.472 235.951L248.57 242.52L259.152 252.925L237.01 249.534V255.111L266.789 262.064C272.872 263.188 274.052 255.809 271.843 253.431L271.853 253.441Z",
    fill: "url(#paint15_linear_401_54310)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M271.852 253.441L254.471 235.951L252.746 237.864L269.633 254.868C271.035 256.376 271.065 259.908 269.33 261.993C273.143 260.931 273.688 255.435 271.842 253.441H271.852Z",
    fill: "#FFEAE0"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M259.848 241.366L254.472 235.961L248.57 242.53L253.574 247.449C255.692 245.445 257.78 243.43 259.838 241.366H259.848Z",
    fill: "#DB6C51"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M272.73 255.242L271.852 253.451L259.162 252.935L237.02 249.544V250.789L264.65 255.971L272.538 258.734C272.912 257.58 272.972 256.315 272.73 255.242Z",
    fill: "#FFEAE0"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M238.765 255.545L231.734 261.648L224.279 258.602L224.864 250.808L233.59 250.525L234.821 247.276L234.549 241.152L237.605 242.468L239.461 249.958L238.765 255.545Z",
    fill: "url(#paint16_linear_401_54310)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M234.549 241.152L236.556 243.592L236.647 250.039L231.765 253.015L231.734 261.648L238.765 255.545L239.714 250.899L239.462 249.958L237.605 242.468L234.549 241.152Z",
    fill: "#FFEAE0"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M162.402 241.922L156.602 265.211L185.17 254.24L185.392 259.391L153.697 272.863C151.044 273.986 148.209 271.679 148.774 268.845L153.929 242.823L162.412 241.922H162.402Z",
    fill: "url(#paint17_linear_401_54310)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M185.16 254.24L156.592 265.211L161.747 244.544L157.217 243.774L154.665 264.969L152.426 268.572L185.16 254.24Z",
    fill: "#FFEAE0"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M158.205 258.754L162.402 241.922L153.918 242.813L151.406 255.495C153.585 256.841 155.815 257.974 158.205 258.744V258.754Z",
    fill: "#DB6C51"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M161.515 222.003C161.515 222.003 149.762 228.369 144.355 243.47C144.355 243.47 154.463 255.737 169.04 255.494L172.571 235.687C172.571 235.687 172.803 227.195 161.525 222.003H161.515Z",
    fill: "url(#paint18_linear_401_54310)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M183.052 260.737L193.634 264.107L204.559 260.565L202.874 250.454L191.787 252.984L188.933 252.306L186.915 243.379L184.403 244.897L182.355 255.15L183.052 260.737Z",
    fill: "url(#paint19_linear_401_54310)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M202.873 250.454L204.558 260.565L193.633 264.108L191.787 252.984L202.873 250.454Z",
    fill: "#FFEAE0"
  }))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.418 135.7C364.857 135.7 358.728 141.862 358.728 149.464V195.592C358.728 197.646 357.072 199.312 355.028 199.312C352.985 199.312 351.328 197.646 351.328 195.592V149.464C351.328 137.753 360.77 128.26 372.418 128.26C384.066 128.26 393.508 137.753 393.508 149.464V151.329C393.508 153.384 391.852 155.049 389.808 155.049C387.765 155.049 386.108 153.384 386.108 151.329V149.464C386.108 141.862 379.979 135.7 372.418 135.7Z",
    fill: "url(#paint20_linear_401_54310)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_401_54310",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 351,
    y: 128,
    width: 43,
    height: 72
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.418 135.7C364.857 135.7 358.728 141.862 358.728 149.464V195.592C358.728 197.646 357.072 199.312 355.028 199.312C352.985 199.312 351.328 197.646 351.328 195.592V149.464C351.328 137.753 360.77 128.26 372.418 128.26C384.066 128.26 393.508 137.753 393.508 149.464V151.329C393.508 153.384 391.852 155.049 389.808 155.049C387.765 155.049 386.108 153.384 386.108 151.329V149.464C386.108 141.862 379.979 135.7 372.418 135.7Z",
    fill: "#4D94FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_401_54310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.475 142.023C359.475 134.886 366.774 129.018 376.12 128.327C377.139 128.252 377.969 127.427 377.969 126.399V122.679C377.969 121.652 377.138 120.815 376.117 120.863C361.246 121.573 349.479 130.776 349.479 142.023V188.151C349.479 190.206 351.716 191.871 354.477 191.871C357.237 191.871 359.475 190.206 359.475 188.151V142.023Z",
    fill: "url(#paint21_linear_401_54310)"
  }))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M409.788 208.426C409.788 229.074 393.14 245.812 372.603 245.812C352.066 245.812 335.418 229.074 335.418 208.426C335.418 187.778 352.066 171.04 372.603 171.04C393.14 171.04 409.788 187.778 409.788 208.426Z",
    fill: "url(#paint22_linear_401_54310)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_401_54310",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 335,
    y: 171,
    width: 75,
    height: 75
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M409.788 208.426C409.788 229.074 393.14 245.812 372.603 245.812C352.066 245.812 335.418 229.074 335.418 208.426C335.418 187.778 352.066 171.04 372.603 171.04C393.14 171.04 409.788 187.778 409.788 208.426Z",
    fill: "url(#paint23_linear_401_54310)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_401_54310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.268 207.31C411.268 227.958 394.62 244.696 374.083 244.696C353.547 244.696 336.898 227.958 336.898 207.31C336.898 186.662 353.547 169.924 374.083 169.924C394.62 169.924 411.268 186.662 411.268 207.31Z",
    fill: "#4383FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.858 206.194C413.858 226.841 397.21 243.58 376.673 243.58C356.137 243.58 339.488 226.841 339.488 206.194C339.488 185.546 356.137 168.808 376.673 168.808C397.21 168.808 413.858 185.546 413.858 206.194Z",
    fill: "url(#paint24_linear_401_54310)"
  }))), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M378.634 209.266C378.634 208.577 379.021 207.955 379.59 207.571C382.405 205.666 384.258 202.431 384.258 198.761C384.258 192.902 379.537 188.152 373.713 188.152C367.889 188.152 363.168 192.902 363.168 198.761C363.168 202.26 364.852 205.363 367.449 207.296C367.973 207.685 368.323 208.282 368.323 208.937V226.84C368.323 227.868 369.152 228.7 370.173 228.7H376.784C377.806 228.7 378.634 227.868 378.634 226.84V209.266Z",
    fill: "url(#paint25_linear_401_54310)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M414.118 152.898C414.332 152.529 414.863 152.529 415.077 152.898L415.872 154.269C415.898 154.315 415.942 154.347 415.993 154.358L417.535 154.693C417.951 154.784 418.115 155.292 417.831 155.611L416.78 156.794C416.745 156.833 416.729 156.885 416.734 156.937L416.893 158.515C416.936 158.941 416.506 159.255 416.117 159.082L414.672 158.442C414.625 158.421 414.571 158.421 414.523 158.442L413.079 159.082C412.69 159.255 412.26 158.941 412.303 158.515L412.462 156.937C412.467 156.885 412.45 156.833 412.416 156.794L411.364 155.611C411.081 155.292 411.245 154.784 411.661 154.693L413.203 154.358C413.254 154.347 413.298 154.315 413.324 154.269L414.118 152.898ZM414.758 153.085C414.686 152.962 414.509 152.962 414.438 153.085L413.644 154.457C413.565 154.592 413.434 154.688 413.282 154.721L411.739 155.057C411.6 155.087 411.546 155.256 411.64 155.363L412.692 156.546C412.796 156.663 412.846 156.818 412.83 156.974L412.671 158.553C412.657 158.695 412.8 158.799 412.93 158.742L414.374 158.102C414.517 158.039 414.679 158.039 414.822 158.102L416.266 158.742C416.396 158.799 416.539 158.695 416.525 158.553L416.366 156.974C416.35 156.818 416.4 156.663 416.504 156.546L417.556 155.363C417.65 155.256 417.595 155.087 417.457 155.057L415.914 154.721C415.762 154.688 415.63 154.592 415.552 154.457L414.758 153.085Z",
    fill: "#6F6CFF"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.796364,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.694 122.685C329.814 123.095 329.45 123.483 329.035 123.386L325.647 122.591C325.596 122.58 325.543 122.59 325.5 122.619L322.63 124.597C322.279 124.839 321.799 124.61 321.763 124.184L321.468 120.698C321.464 120.646 321.438 120.599 321.397 120.567L318.639 118.434C318.301 118.173 318.369 117.644 318.761 117.477L321.967 116.118C322.015 116.098 322.052 116.058 322.07 116.009L323.235 112.712C323.378 112.31 323.9 112.211 324.178 112.534L326.455 115.18C326.489 115.219 326.538 115.243 326.59 115.244L330.068 115.34C330.493 115.352 330.748 115.82 330.528 116.186L328.729 119.181C328.702 119.225 328.695 119.279 328.71 119.329L329.694 122.685ZM329.119 123.024C329.257 123.056 329.379 122.927 329.339 122.79L328.355 119.435C328.311 119.284 328.331 119.122 328.412 118.988L330.211 115.994C330.284 115.872 330.199 115.716 330.058 115.712L326.579 115.616C326.424 115.612 326.277 115.542 326.175 115.423L323.898 112.778C323.805 112.67 323.631 112.703 323.584 112.837L322.418 116.133C322.366 116.281 322.255 116.4 322.111 116.461L318.905 117.82C318.774 117.876 318.752 118.052 318.864 118.139L321.622 120.272C321.746 120.368 321.824 120.511 321.837 120.667L322.132 124.153C322.144 124.295 322.304 124.371 322.421 124.29L325.291 122.312C325.419 122.224 325.579 122.194 325.731 122.229L329.119 123.024Z",
    fill: "#6F6CFF"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73011,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.93 241.547C320.343 241.648 320.493 242.16 320.202 242.472L318.485 244.303C318.45 244.341 318.432 244.392 318.435 244.444L318.621 246.953C318.653 247.379 318.215 247.682 317.831 247.499L315.568 246.423C315.521 246.401 315.467 246.4 315.419 246.42L313.103 247.373C312.71 247.535 312.289 247.209 312.343 246.785L312.661 244.29C312.667 244.238 312.652 244.186 312.618 244.146L311.001 242.226C310.726 241.9 310.904 241.396 311.322 241.317L313.781 240.85C313.832 240.84 313.876 240.81 313.904 240.765L315.22 238.625C315.444 238.262 315.975 238.276 316.179 238.651L317.38 240.858C317.405 240.904 317.448 240.937 317.499 240.949L319.93 241.547ZM319.932 242.216C320.03 242.113 319.979 241.942 319.842 241.908L317.411 241.311C317.26 241.273 317.131 241.174 317.056 241.037L315.854 238.83C315.786 238.705 315.609 238.7 315.535 238.821L314.218 240.961C314.136 241.094 314.002 241.186 313.849 241.216L311.39 241.683C311.251 241.709 311.192 241.877 311.284 241.986L312.901 243.905C313.001 244.025 313.047 244.182 313.028 244.337L312.71 246.833C312.692 246.974 312.832 247.082 312.963 247.028L315.279 246.075C315.423 246.016 315.586 246.02 315.727 246.087L317.989 247.162C318.117 247.223 318.263 247.123 318.252 246.981L318.067 244.472C318.055 244.315 318.109 244.161 318.216 244.047L319.932 242.216Z",
    fill: "#6F6CFF"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.902331,
    d: "M448.904 196.785C449.091 196.999 448.979 197.337 448.701 197.394L445.294 198.105C445.192 198.126 445.104 198.189 445.051 198.279L443.273 201.286C443.128 201.531 442.774 201.528 442.634 201.281L440.909 198.242C440.858 198.151 440.771 198.087 440.669 198.064L437.275 197.293C436.999 197.23 436.892 196.891 437.083 196.68L439.424 194.092C439.494 194.015 439.528 193.911 439.519 193.807L439.199 190.324C439.173 190.04 439.461 189.833 439.72 189.95L442.891 191.389C442.986 191.432 443.094 191.433 443.19 191.392L446.386 190.01C446.646 189.897 446.931 190.109 446.9 190.392L446.519 193.869C446.507 193.973 446.54 194.077 446.609 194.156L448.904 196.785Z",
    fill: "#6F6CFF"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.370759,
    d: "M304.435 165.195C304.52 164.923 304.866 164.845 305.059 165.054L306.468 166.579C306.539 166.655 306.638 166.698 306.742 166.698L308.813 166.681C309.096 166.679 309.277 166.985 309.139 167.234L308.132 169.053C308.081 169.144 308.071 169.253 308.104 169.352L308.76 171.326C308.85 171.597 308.616 171.864 308.338 171.809L306.306 171.408C306.204 171.388 306.098 171.412 306.014 171.474L304.349 172.711C304.121 172.881 303.796 172.74 303.762 172.457L303.513 170.39C303.501 170.286 303.446 170.193 303.361 170.132L301.676 168.922C301.445 168.756 301.478 168.402 301.735 168.282L303.614 167.405C303.708 167.361 303.779 167.279 303.811 167.18L304.435 165.195Z",
    fill: "#6F6CFF"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.806242,
    d: "M326.119 204.34C325.977 204.586 325.623 204.586 325.48 204.34L323.728 201.317C323.676 201.227 323.589 201.163 323.487 201.141L320.086 200.4C319.809 200.34 319.7 200.001 319.889 199.789L322.207 197.18C322.276 197.102 322.31 196.999 322.299 196.895L321.949 193.414C321.92 193.13 322.206 192.921 322.466 193.036L325.65 194.447C325.745 194.489 325.853 194.489 325.948 194.447L329.133 193.036C329.392 192.921 329.678 193.13 329.65 193.414L329.299 196.894C329.289 196.998 329.322 197.102 329.392 197.18L331.71 199.788C331.899 200.001 331.79 200.34 331.513 200.4L328.112 201.14C328.01 201.163 327.923 201.227 327.87 201.317L326.119 204.34Z",
    fill: "#6F6CFF"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.547916,
    d: "M391.881 122.648C391.6 122.683 391.385 122.399 391.494 122.136L392.826 118.904C392.866 118.808 392.864 118.699 392.82 118.604L391.346 115.435C391.226 115.177 391.428 114.884 391.711 114.907L395.179 115.182C395.283 115.19 395.385 115.154 395.461 115.083L398.004 112.695C398.211 112.5 398.55 112.603 398.616 112.88L399.428 116.282C399.452 116.383 399.518 116.47 399.608 116.521L402.653 118.214C402.901 118.352 402.909 118.708 402.667 118.857L399.7 120.684C399.612 120.738 399.55 120.828 399.53 120.93L398.869 124.365C398.815 124.645 398.481 124.763 398.266 124.577L395.62 122.305C395.541 122.237 395.438 122.206 395.334 122.218L391.881 122.648Z",
    fill: "#6F6CFF"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.392959,
    d: "M394.175 269.577C394.053 269.834 393.7 269.863 393.538 269.628L391.553 266.755C391.494 266.669 391.401 266.613 391.298 266.599L387.85 266.133C387.569 266.095 387.433 265.766 387.604 265.539L389.709 262.753C389.772 262.67 389.797 262.564 389.778 262.461L389.153 259.02C389.103 258.739 389.371 258.508 389.639 258.602L392.925 259.753C393.023 259.788 393.131 259.779 393.222 259.729L396.285 258.068C396.534 257.933 396.836 258.119 396.83 258.404L396.756 261.901C396.754 262.006 396.796 262.106 396.871 262.178L399.388 264.593C399.594 264.79 399.511 265.136 399.24 265.219L395.909 266.229C395.809 266.259 395.727 266.33 395.682 266.424L394.175 269.577Z",
    fill: "#6F6CFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_401_54310",
    x1: 116.397,
    y1: 209.429,
    x2: 156.075,
    y2: 342.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#8AE882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#86E680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#7AE07C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#67D875"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#4CCB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2CBD61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_401_54310",
    x1: 282.628,
    y1: 329.401,
    x2: 149.953,
    y2: 312.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#8AE882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#86E680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#7AE07C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#67D875"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#4CCB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2CBD61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_401_54310",
    x1: 262.829,
    y1: 215.758,
    x2: 178.043,
    y2: 271.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#8AE882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#86E680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#7AE07C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#67D875"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#4CCB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2CBD61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_401_54310",
    x1: 138.994,
    y1: 127.136,
    x2: 170.75,
    y2: 279.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#8AE882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#86E680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#7AE07C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#67D875"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#4CCB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2CBD61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_401_54310",
    x1: 300.559,
    y1: 164.882,
    x2: 183.641,
    y2: 194.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#8AE882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#86E680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#7AE07C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#67D875"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#4CCB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2CBD61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_401_54310",
    x1: 180.743,
    y1: 88.8229,
    x2: 187.243,
    y2: 198.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#8AE882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#86E680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#7AE07C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#67D875"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#4CCB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2CBD61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_401_54310",
    x1: 151.69,
    y1: 249.866,
    x2: 249.419,
    y2: 249.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D14444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_401_54310",
    x1: 227.488,
    y1: 202.57,
    x2: 176.876,
    y2: 308.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_401_54310",
    x1: 210.946,
    y1: 192.327,
    x2: 176.372,
    y2: 130.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD7C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_401_54310",
    x1: 196.733,
    y1: 105.153,
    x2: 142.065,
    y2: 151.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D14444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_401_54310",
    x1: 197.025,
    y1: 106.691,
    x2: 147.375,
    y2: 136.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_401_54310",
    x1: 223.071,
    y1: 107.42,
    x2: 150.592,
    y2: 177.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D14444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_401_54310",
    x1: 243.973,
    y1: 109.789,
    x2: 56.0435,
    y2: 172.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_401_54310",
    x1: 246.111,
    y1: 116.165,
    x2: 58.1818,
    y2: 179.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_401_54310",
    x1: 169.746,
    y1: 215.405,
    x2: 135.182,
    y2: 153.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD7C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_401_54310",
    x1: 256.651,
    y1: 264.878,
    x2: 247.147,
    y2: 213.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD7C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_401_54310",
    x1: 229.192,
    y1: 273.45,
    x2: 240.077,
    y2: 189.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD7C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_401_54310",
    x1: 169.232,
    y1: 279.836,
    x2: 157.961,
    y2: 193.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD7C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_401_54310",
    x1: 174.467,
    y1: 220.859,
    x2: 135.883,
    y2: 280.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D14444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_401_54310",
    x1: 195.833,
    y1: 276.375,
    x2: 184.572,
    y2: 189.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD7C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_401_54310",
    x1: 387.588,
    y1: 165.088,
    x2: 347.233,
    y2: 155.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93B0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5694FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_401_54310",
    x1: 352.477,
    y1: 180.153,
    x2: 359.985,
    y2: 136.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70B5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADCCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_401_54310",
    x1: 372.603,
    y1: 171.04,
    x2: 378.587,
    y2: 250.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#759CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70BAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_401_54310",
    x1: 372.603,
    y1: 171.04,
    x2: 372.603,
    y2: 245.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAB8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61A0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_401_54310",
    x1: 376.673,
    y1: 168.808,
    x2: 376.673,
    y2: 243.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAB8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61A0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_401_54310",
    x1: 363.168,
    y1: 211.727,
    x2: 381.024,
    y2: 221.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0048FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5081FD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_401_54310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 564.118,
    height: 514,
    fill: "white",
    transform: "translate(0.46875 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.8e58272d21e63fccf7717d96a34196dd.svg";
export { ForwardRef as ReactComponent };